let bannerInfo = document.querySelectorAll(".block_banner-slider");

bannerInfo.forEach((event) => {
  let autoplayTime = event.getAttribute("data-autoplaytime");
  let autoplay = event.getAttribute("data-autoplay").replaceAll(/\s/g, "");
  
  let valshow = String(autoplay).toLowerCase();
  let autoplayinfo;
  if (valshow == "true") {
    autoplayinfo = {
      delay: Number(autoplayTime),
    };
  }else{
    autoplayinfo = false
  }

  let bannerSwiper = new Swiper(".block_banner-slider", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    autoplay: autoplayinfo,
    loop: true,
  });
});


equl(`.block_collection-button-aligment`)
